import { MARQUEE } from "@/data/site";

const Row = ({ hidden }) => (
  <ul className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {MARQUEE.map((item) => (
      <li key={item} className="flex items-center">
        <span className="px-6 font-display text-3xl font-bold tracking-tight sm:px-10 sm:text-5xl lg:text-6xl">{item}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 text-lime sm:h-9 sm:w-9" aria-hidden="true">
          <path fill="currentColor" d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
        </svg>
      </li>
    ))}
  </ul>
);

export const Marquee = () => (
  <section aria-label="Our disciplines" className="on-dark overflow-hidden bg-navy py-8 text-white sm:py-10" data-testid="disciplines-marquee">
    <div className="marquee-track flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
